"use client";

import Image from "next/image";

export default function OffshoreHero() {
  return (
    <section className="relative w-full py-22 sm:py-16 lg:py-20 xl:py-24 2xl:py-28 px-4 sm:px-6 lg:px-8 bg-[#FAFAFA] overflow-hidden">
      
      {/* subtle background effect */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-[#B8893A]/10 blur-[120px] rounded-full pointer-events-none" />

      <div className="relative w-full mx-auto max-w-[1280px] lg:max-w-[1440px] xl:max-w-[1600px] 2xl:max-w-[1800px] grid md:grid-cols-2 gap-8 lg:gap-12 xl:gap-16 items-center px-0">
        
        {/* LEFT CONTENT */}
        <div className="text-left md:text-left">
          
          {/* badge */}
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#B8893A] border border-[#B8893A]/20 text-[#ffffff] text-[11px] sm:text-xs font-bold mb-5 sm:mb-6">
            <span className="w-1.5 h-1.5 rounded-full bg-[#fafafa]" />
            Offshore Company Setup
          </div>

          {/* heading */}
          <h1 
            className="font-bold text-[#000000] tracking-tight mb-6 sm:mb-8"
            style={{ fontSize: "clamp(28px, 5vw, 48px)", fontWeight: "700", lineHeight: "1.3" }}
          >
            Offshore{" "}
            <span className="text-[#000000] relative inline-block">
              Business Setup
              <span className="absolute left-0 bottom-1 w-full h-[6px] bg-[#B8893A]/20 -z-10 rounded" />
            </span>
          </h1>

          {/* description */}
          <p 
            className="text-black max-w-2xl mb-8 sm:mb-10 mx-auto md:mx-0"
            style={{ fontSize: "clamp(14px, 1.2vw, 16px)", lineHeight: "1.6" }}
          >
            Operate globally from the UAE without a physical presence. Offshore companies offer maximum privacy, asset protection, and 0% tax ideal for international investors and holding structures.
          </p>

          {/* buttons */}
          <div className="flex flex-col sm:flex-row gap-4 sm:gap-5 justify-center md:justify-start pt-4">
            
            <a
              href="/contact"
              className="px-6 sm:px-8 lg:px-10 py-3 sm:py-3.5 lg:py-4 bg-[#B8893A] hover:bg-[#A67B34] text-white font-semibold lg:font-bold rounded-xl transition-all duration-300 shadow-md hover:shadow-lg active:scale-[0.98] text-center text-sm sm:text-base"
            >
              Get Started
            </a>

            <a
              href="/calculator"
              className="px-6 sm:px-8 lg:px-10 py-3 sm:py-3.5 lg:py-4 border border-gray-300 text-gray-700 font-semibold rounded-xl hover:bg-gray-50 transition-all duration-300 active:scale-[0.98] text-center text-sm sm:text-base"
            >
              Calculate Your Cost
            </a>

          </div>
        </div>

        {/* RIGHT IMAGE */}
        <div className="relative w-full h-full min-h-[300px]">
          
          <div className="relative w-full h-[300px] sm:h-[400px] lg:h-[500px] xl:h-[550px] 2xl:h-[600px] overflow-hidden shadow-xl rounded-2xl">
            <Image
              src="https://plus.unsplash.com/premium_photo-1661772661721-b16346fe5b0f?q=80&w=870&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
              alt="Offshore Business Setup"
              fill
              className="object-cover"
              priority
            />
          </div>

        </div>

      </div>
    </section>
  );
}
